import { render, staticRenderFns } from "./ManageComplaints.vue?vue&type=template&id=9ca7455a"
import script from "./ManageComplaints.vue?vue&type=script&lang=js"
export * from "./ManageComplaints.vue?vue&type=script&lang=js"
import style0 from "./ManageComplaints.vue?vue&type=style&index=0&id=9ca7455a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports